import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import Topsection from "./Topsection";
import Frontpopup_form from "./Frontpopup_form";
// import Rightside from "./Rightside";
import "animate.css/animate.min.css";
import FloatingButton from "./FloatingButton";
import Mobilefooterbtn from "./Mobilefooterbtn";
import { Link } from "react-router-dom";

import { Helmet } from "react-helmet";

const About = () => {
  return (
    <>
      <Helmet>
        <title>Fortune Cloud Technologies | About Us</title>
        <meta
          name="description"
          content="Explore courses and training programs at Fortune Cloud Technologies. Learn with experts and get placed."
        />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <div className="bgimage">
        <Topsection />
        <Header />
        {/* <div className="text-center">
        <img
          src="/assets/images/FCT2.jpeg"
          alt="About Us"
          className="img-fluid"
        />
      </div> */}

        <div className="container">
          <h2 className="text-center m-4 myfont1 animate__animated animate__slow animate__fadeInDown fw-bold">
            We Understand Technology
          </h2>
          <div className="row align-items-center m-2">
            {/* Left Column */}
            <div className="col-12 col-lg-6">
              <div className="row gy-4">
                <div className="col-6 col-sm-6 animate__animated animate__slow animate__fadeInDown">
                  <div className="card shadow-sm h-100 text-center p-3 bg1 text-white">
                    <div className="mb-3">
                      <i className="bi bi-mortarboard-fill fs-1 text-white"></i>
                    </div>
                    <h5 className="card-title">Top Instructors</h5>
                  </div>
                </div>
                <div className="col-6 col-sm-6 animate__animated animate__slow animate__fadeInDown">
                  <div className="card shadow-sm h-100 text-center bg2 p-3 text-white">
                    <div className="mb-3">
                      <i className="bi bi-person-check fs-1 text-white"></i>
                    </div>
                    <h5 className="card-title">5000+ Trained Students</h5>
                  </div>
                </div>
                <div className="col-6 col-sm-6 animate__animated animate__slow animate__fadeInDown">
                  <div className="card shadow-sm h-100 text-center p-3 bg2 text-white">
                    <div className="mb-3">
                      <i className="bi bi-suitcase-lg fs-1 text-white"></i>
                    </div>
                    <h5 className="card-title">2000+ Client Companies</h5>
                  </div>
                </div>
                <div className="col-6 col-sm-6 animate__animated animate__slow animate__fadeInDown">
                  <div className="card shadow-sm h-100 text-center p-3 bg1 text-white">
                    <div className="mb-3">
                      <i className="bi bi-trophy-fill fs-1 text-white"></i>
                    </div>
                    <h5 className="card-title"> 100% Placement</h5>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column */}
            <div className="col-12 col-lg-6 text-center mt-4 mt-lg-0">
              <img
                src="/assets/images/devices.webp"
                alt="Devices About"
                className="img-fluid animate__animated animate__slow animate__fadeInDown"
              />
            </div>
          </div>
        </div>
        <hr />
        <div className="container py-4">
          <h2 className="text-center m-4 myfont1 animate__animated animate__slow animate__fadeInDown fw-bold">
            About Us
          </h2>

          <div className="row g-4">
            {/* Left Column - Text Content */}
            <div className="col-lg-7 pe-lg-4">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body p-4">
                  <h3 className="mb-4 fw-bold text-primary">
                    Building Skills, Not Just Selling Dreams
                  </h3>

                  <div
                    className="text-content"
                    style={{
                      maxHeight: "600px",
                      overflowY: "auto",
                      paddingRight: "10px",
                    }}
                  >
                    <p className="lead">
                      At <strong>Fortune Cloud Technologies</strong>, we don't
                      sell dreams — we build skills.
                    </p>

                    <p>
                      Founded in 2015 and a subsidiary of{" "}
                      <strong>Cravita Technologies</strong>, a growing software
                      product company, we know exactly what today's IT industry
                      expects from freshers — and we train students accordingly.
                      Our training programs are carefully designed by industry
                      experts who work hands-on in tech, ensuring every learner
                      is groomed with the skills that actually matter in real
                      jobs.
                    </p>

                    <p>We offer career-focused training in:</p>

                    <ul className="list-unstyled row row-cols-1 row-cols-md-2 g-2 mb-4">
                      <li className="col">
                        <a
                          href="/course/Full-Stack-Development"
                          className="text-decoration-none"
                        >
                          <div className="p-2 bg-light rounded hover-shadow">
                            <strong>Full Stack Development</strong>
                          </div>
                        </a>
                      </li>
                      <li className="col">
                        <a
                          href="/course/Cloud-Computing"
                          className="text-decoration-none"
                        >
                          <div className="p-2 bg-light rounded hover-shadow">
                            <strong>
                              Cloud Computing (AWS, Azure, DevOps)
                            </strong>
                          </div>
                        </a>
                      </li>
                      <li className="col">
                        <a
                          href="/course/Data-Science-&-Data-Analytics"
                          className="text-decoration-none"
                        >
                          <div className="p-2 bg-light rounded hover-shadow">
                            <strong>Data Analytics</strong>
                          </div>
                        </a>
                      </li>
                      <li className="col">
                        <a
                          href="/course/Data-Science-&-Data-Analytics"
                          className="text-decoration-none"
                        >
                          <div className="p-2 bg-light rounded hover-shadow">
                            <strong>Data Science</strong>
                          </div>
                        </a>
                      </li>
                      <li className="col">
                        <a
                          href="/course/Cyber-Security"
                          className="text-decoration-none"
                        >
                          <div className="p-2 bg-light rounded hover-shadow">
                            <strong>Cyber Security</strong>
                          </div>
                        </a>
                      </li>
                      <li className="col">
                        <a
                          href="/course/MERN-Stack-Development"
                          className="text-decoration-none"
                        >
                          <div className="p-2 bg-light rounded hover-shadow">
                            <strong>MERN stack Developement</strong>
                          </div>
                        </a>
                      </li>
                    </ul>

                    <p>
                      Our programs blend theory with hands-on practice,
                      real-time projects, and internship opportunities. Every
                      student gets a chance to showcase their work through
                      GitHub repositories, live hosting URLs, or real-time
                      deployments — because in today's world, a strong digital
                      portfolio speaks louder than just a resume.
                    </p>

                    <div className="bg-primary text-white p-4 rounded">
                      <p className="fw-bold fs-5 mb-2 text-white">
                        👉 At Fortune Cloud, our promise is simple:
                      </p>
                      <p className="fw-bold fs-3 mb-0">100% Skills = 100% Job</p>
                    </div>

                    <p>
                      We're not here to give you shortcuts. We're here to make
                      you capable — to learn, adapt, face challenges, and win in
                      today's competitive world.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column - Video */}
            <div className="col-lg-5">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body p-4 d-flex flex-column">
                  <h3 className="mb-4 fw-bold text-primary">Our Story</h3>
                  <div className="ratio ratio-16x9 mb-4">
                    <iframe
                      src="https://www.youtube.com/embed/uHMUAdvC0DQ"
                      title="Welcome to Fortune Cloud Technologies - India's Most Trusted IT Training & Placement Institute"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowFullScreen
                      className="rounded"
                      style={{ border: "none" }}
                    ></iframe>
                  </div>

                  <div className="mt-auto">
                    <div className="bg-primary text-white p-4 rounded">
                      <h4 className="fw-bold">Key Achievements</h4>
                      <ul className="list-styled">
                        <li className="text-justify mb-2">
                          2000+ placements in reputed companies
                        </li>
                        <li className="text-justify mb-2">
                          Industry-designed curriculum
                        </li>
                        <li className="text-justify mb-2">
                          Real-world project experience
                        </li>
                        <li className="text-justify mb-2">
                          Dedicated placement support
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="features p-4">
          <div className="container">
            <div className="row">
              <div className="col-md-4">
                {/* card */}
                <div className="card mb-2">
                  <div className="card-body">
                    <h4 className="card-title text-center myfont1 fw-bold mb-4">
                      Our Key Features
                    </h4>
                    <p className="card-text text-start lead text-bold">
                      <strong>
                        <ul>
                          <li>Industry based curriculum</li>
                          <li>Job oriented trainings to make you employable</li>
                          <li>Certified faculty and trainers</li>
                          <li>
                            100% sure Internship to gain hands on experience on
                            Live environment
                          </li>
                          <li>100% sure Placement Assurance</li>
                        </ul>
                      </strong>
                    </p>
                  </div>
                </div>
                {/* card */}
              </div>
              <div className="col-md-4">
                {/* card */}
                <div class="card mb-2">
                  <div class="card-body">
                    <h4 class="card-title text-center myfont1 fw-bold mb-4">
                      Our Objectives
                    </h4>
                    <p class="card-text text-start lead text-bold">
                      <strong>
                        <ul>
                          <li>
                            To serve any individuals having any background
                          </li>
                          <li>
                            To provide interactive environment for training
                            purpose
                          </li>
                          <li>
                            To serve the society by putting utmost efforts
                          </li>
                          <li>Bridge the Skill Gap</li>
                        </ul>
                      </strong>
                    </p>
                  </div>
                </div>
                {/* card */}
              </div>
              <div className="col-md-4">
                {/* card */}
                <div class="card mb-2">
                  <div class="card-body">
                    <h4 class="card-title text-center myfont1 fw-bold mb-4">
                      Our Services
                    </h4>
                    <p class="card-text text-start lead text-bold">
                      <strong>
                        <ul>
                          <li>Job oriented courses</li>
                          <li>Staffing & Recruitment</li>
                          <li>Placement Assistance</li>
                          <li>Online & Offline Learning Options</li>
                          <li>Soft Skills & Career Development</li>
                          <li>Internship & Project Support</li>
                        </ul>
                      </strong>
                      <br className="d-none d-sm-block" />
                    </p>
                  </div>
                </div>
                {/* card */}
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row">
            <div className="col-md-3 py-4">
              <div className="col d-flex align-content-center justify-content-center flex-wrap">
                <img src="/assets/images/que.jpeg" width="220" height="200" />
              </div>
            </div>
            <div className="col-md-9 py-4">
              <h2 className="myfont1 fw-bold mt-2 text-start">What we do ?</h2>
              <p className="text-justify lead text-bold m-2" >
                <strong>
                  We offer Training cum Internship Programs with 100% Placement
                  Assurance in high-demand IT domains, including:&nbsp;
                  <Link
                    to="/course/Full-Stack-Development"
                    className="text-decoration-none"
                  >
                    Full Stack Development (Java / Python / .NET)
                  </Link>
                  ,
                  <Link
                    to="/course/Web-Development"
                    className="text-decoration-none"
                  >
                    {" "}
                    Web Development
                  </Link>
                  ,
                  <Link
                    to="/course/MERN-Stack-Development"
                    className="text-decoration-none"
                  >
                    {" "}
                    MERN Stack Development
                  </Link>
                  ,
                  <Link
                    to="/course/Software-Testing"
                    className="text-decoration-none"
                  >
                    {" "}
                    Software Testing
                  </Link>
                  ,
                  <Link
                    to="/course/Cloud-Computing"
                    className="text-decoration-none"
                  >
                    {" "}
                    Cloud Computing (AWS + DevOps)
                  </Link>
                  ,
                  <Link
                    to="/course/Data-Science-&-Data-Analytics"
                    className="text-decoration-none"
                  >
                    {" "}
                    Data Science & Analytics
                  </Link>
                  ,
                  <Link
                    to="/course/Data-Science-&-Data-Analytics"
                    className="text-decoration-none"
                  >
                    {" "}
                    Data Analytics
                  </Link>
                  ,
                  <Link
                    to="/course/Cyber-Security"
                    className="text-decoration-none"
                  >
                    {" "}
                    Cyber Security
                  </Link>
                  ,
                  <Link
                    to="/course/Android-Development"
                    className="text-decoration-none"
                  >
                    {" "}
                    Android Development
                  </Link>
                  ,
                  <Link
                    to="/course/Digital-Marketing"
                    className="text-decoration-none"
                  >
                    {" "}
                    Digital Marketing
                  </Link>
                  .
                </strong>
              </p>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row mb-4 mt-4 ms-4 me-4">
            <div className="col-md-6 mb-2">
              <div className="card shadow-sm h-100 text-center p-3 lead text-bold">
                <div className="mb-3">
                  <i className="bi bi-rocket fs-1 text-primary"></i>
                </div>
                <h5 className="card-title">Our Vision</h5>
                <p className="card-text">
                  <strong>
                    We have a clear vision to build a strong reputation to offer
                    Excellent IT training to the employed and unemployed
                    individuals to improve their knowledge & qualities in the
                    desired field.
                  </strong>
                </p>
              </div>
            </div>
            <div className="col-md-6 mb-2">
              <div className="card shadow-sm h-100 text-center p-3 lead text-bold">
                <div className="mb-3">
                  <i className="bi bi-eye fs-1 text-primary"></i>
                </div>
                <h5 className="card-title">Our Mission</h5>
                <p className="card-text">
                  <strong>
                    We aim to make candidates expert and offer them a better
                    training experience to survive in the industries
                  </strong>
                </p>
                {/* <a href="#" className="btn btn-outline-success mt-auto">
                Meet Our Team
              </a> */}
              </div>
            </div>
          </div>
        </div>

        <Footer />
        {/* <Rightside/> */}
        <FloatingButton />
        <Mobilefooterbtn />
        <Frontpopup_form />
      </div>
    </>
  );
};

export default About;
